import { X } from "lucide-react";

/**
 * × icon button. Tapping opens the parent's <ExitConfirmDialog>.
 */
export function SluitenButton({ onRequest }: { onRequest: () => void }) {
  return (
    <button
      type="button"
      onClick={onRequest}
      aria-label="Examen sluiten"
      className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[var(--border-strong)] bg-[var(--panel)] text-[var(--ink-muted)] hover:bg-[var(--panel-soft)] hover:text-[var(--ink)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2 transition-colors"
    >
      <X size={18} aria-hidden />
    </button>
  );
}
